import { render, staticRenderFns } from "./JcomSettingEdit.vue?vue&type=template&id=268115bd"
import script from "./JcomSettingEdit.vue?vue&type=script&lang=js"
export * from "./JcomSettingEdit.vue?vue&type=script&lang=js"
import style0 from "./JcomSettingEdit.vue?vue&type=style&index=0&id=268115bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports